import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { useEffect, useState } from "react"
import { btn, btnPrimary } from "../ds/button.module.css"
import { ArrowBlackDown, ArrowWhiteDown, WhiteArrowRight } from "../ds/Shapes"
import PremagicWhiteLogo from "../images/logo/premagic-logo-white.svg"
import HeroShapeRight from "../images/svgs/hero_shapes2.svg"
import { blogUrl } from "../services/blogLinks"
import useWindowDimensions from "../utils/useWindowDimensions"
import {
  FaBookOpen,
  FaBullhorn,
  FaCalculator,
  FaCalendarDays,
  FaCamera,
  FaChartSimple,
  FaHandshakeAngle,
  FaNewspaper,
  FaTrophy,
  FaUserAstronaut,
  FaUsers,
} from "react-icons/fa6"

import { Dropdown } from "./Dropdown"
import { MegaDropdown } from "./MegaDropdown"
import { close_icon, hamburger, header_sticky } from "./Header.module.css"
import { useAnnouncementBanner } from "./AnnouncementBannerContext"
import { Button } from "../myne/Button/Button"

const caseStudies = [
  // {
  //   to: "/case-study/gitex-global-2025",
  //   title: "GITEX Global 2025",
  //   description:
  //     "Boosting attendee engagement across the entire event lifecycle.",
  // },
  // {
  //   to: "/case-study/opentext",
  //   title: "OpenText",
  //   description: "Driving 70% higher booth footfall at trade shows.",
  // },
  {
    to: "/case-study/gitex-global-2025",
    title: "Gitex Global 2025",
    description: "Powering 200K+ Attendance Through Attendee Advocacy",
  },
  {
    to: "/case-study/ai-everything-mea",
    title: "AI Everything MEA Egypt",
    description: "AI avatar challenge that drove 2,000+ registrations",
  },
  {
    to: "/case-study/middle-east-event-show",
    title: "Middle East Event Show",
    description:
      "Driving ROI for sponsors by turning event photos into branded assets.",
  },
  {
    to: "/case-study/entrepreneurs-organization",
    title: "Entrepreneurs Organization",
    description:
      "Strengthening connections through personalized photo experiences",
  },
  {
    to: "/case-study/khaleejtimes",
    title: "Khaleej Times",
    description: "Scaling event marketing with AI-powered attendee engagement.",
  },
  {
    to: "/case-study/hcl",
    title: "HCL Tech Marketing Awards 2025",
    description: "Powering effortless and privacy-first photo sharing.",
  },
  {
    to: "/case-study/laqshya-live-experiences",
    title: "Laqshya Live Experiences",
    description: "Scaling a premium check-in experience with AI avatar badges",
  },
  {
    to: "/case-study/african-tech-summit",
    title: "African Tech Summit",
    description:
      "Shattering industry benchmarks with a 50% attendee advocacy rate.",
  },
  {
    to: "/case-study/idc",
    title: "IDC Middle East CIO Summit 2025",
    description: "Driving social sharing with AI-powered personalization.",
  },
  {
    to: "/case-study/ifeat",
    title: "IFEAT Annual Conference 2024",
    description: "Delivering measurable value without compromising the brand",
  },
  {
    to: "/case-study/gitex-global",
    title: "GITEX Global 2024",
    description: "Transforming attendees into content creators.",
  },
  {
    to: "/case-study/step-conference",
    title: "Step Conference",
    description: "Creating a stellar global event that surpassed expectations.",
  },
  {
    to: "/case-study/g2-live",
    title: "G2 Live",
    description:
      "Driving exponential sign-up growth with innovative strategies.",
  },
  {
    to: "/case-study/umagine",
    title: "UmagineChennai",
    description: "Delivering an experience that goes beyond just networking.",
  },
  {
    to: "/case-study/saasboomi",
    title: "SaaSBOOMi Annual",
    description: "Tackling the hurdle of event photos management",
  },
  {
    to: "/case-study/nasscom",
    title: "Nasscom GCC Conclave",
    description: "Empowering sponsor-audience engagement ",
  },
  {
    to: "/case-study/wowawards",
    title: "Wow Awards",
    description: "Leveraging the power of instant delivery to create an impact",
  },
  {
    to: "/case-study/showsofindia",
    title: "Shows of India",
    description:
      "Merging creativity and technology to craft an impactful event experience",
  },
  {
    to: "/case-study/asiaberlin",
    title: "Asia Berlin",
    description:
      "A streamlined and innovative event marketing solution for ABS2023",
  },
  {
    to: "/case-study/currency-research",
    title: "Currency Research",
    description: "Breaking Stereotypes at the Banknote Conference.",
  },
  {
    to: "/case-study/real-estate-development-summit",
    title: "Real Estate Development Summit",
    description:
      "Simplifying interactions for enhanced UGC by real estate professionals.",
  },
  {
    to: "/case-study/gla-global",
    title: "GLA Global",
    description: "Bridging language barriers at GLA's milestone global event.",
  },
  {
    to: "/case-study/jsconf",
    title: "JSConf India",
    description:
      "Creating connections through digital tools for the tech community.",
  },
  {
    to: "/case-study/yuva-galam",
    title: "Yuva Galam Padayatra",
    description:
      "Learn how Nara Lokesh's Yuvagalam Padayatra used Premagic to drive TDP's success.",
  },
  {
    to: "/case-study/gtech",
    title: "GTECH Kerala Marathon",
    description:
      "Discover How Premagic Powered GTECH Kerala Marathon 2024 with AI-Driven Photo Distribution.",
  },
]

const caseStudiesMega = {
  featured: {
    label: "Featured stories",
    items: [
      {
        to: "/case-study/gitex-global-2025",
        title: "Gitex Global 2025",
        description: "Powering 200K+ attendance through attendee advocacy.",
        kicker: "Attendee advocacy",
        icon: <FaUsers size={18} />,
        iconBg: "#7251F4",
      },
      {
        to: "/case-study/middle-east-event-show",
        title: "Middle East Event Show",
        description: "Turning event photos into branded sponsor ROI.",
        kicker: "Sponsor ROI",
        icon: <FaHandshakeAngle size={18} />,
        iconBg: "#FF6550",
      },
      {
        to: "/case-study/khaleejtimes",
        title: "Khaleej Times",
        description: "Scaling event marketing with AI-powered engagement.",
        kicker: "AI engagement",
        icon: <FaNewspaper size={18} />,
        iconBg: "#1F2937",
      },
      {
        to: "/case-study/hcl",
        title: "HCL Tech Marketing Awards",
        description: "Effortless and privacy-first photo sharing at scale.",
        kicker: "Awards night",
        icon: <FaTrophy size={18} />,
        iconBg: "#F5B400",
      },
    ],
  },
  sections: [
    {
      label: "More stories",
      items: [
        {
          to: "/case-study/ai-everything-mea",
          title: "AI Everything MEA Egypt",
        },
        {
          to: "/case-study/entrepreneurs-organization",
          title: "Entrepreneurs Organization",
        },
        {
          to: "/case-study/laqshya-live-experiences",
          title: "Laqshya Live Experiences",
        },
        { to: "/case-study/african-tech-summit", title: "African Tech Summit" },
        { to: "/case-study/idc", title: "IDC Middle East CIO Summit" },
        { to: "/case-study/ifeat", title: "IFEAT Annual Conference" },
        { to: "/case-study/gitex-global", title: "GITEX Global 2024" },
        { to: "/case-study/step-conference", title: "Step Conference" },
        { to: "/case-study/saasboomi", title: "SaaSBOOMi Annual" },
      ],
    },
  ],
  viewAll: { to: "/case-study/", label: "View all case studies" },
}

const solutionsMega = {
  featured: {
    label: "Products",
    items: [
      {
        to: "/create-event-marketing-posters/",
        title: "Grow Registrations",
        description: "Personalised posters your attendees share far and wide.",
        kicker: "Referrals",
        icon: <FaBullhorn size={18} />,
        iconBg: "#FF6550",
      },
      {
        to: "/smart-photo-distribution-for-seamless-events/",
        title: "Amplify Reach",
        description: "AI-matched galleries delivered to every attendee.",
        kicker: "Photo UGC",
        icon: <FaCamera size={18} />,
        iconBg: "#7251F4",
      },
      {
        to: "/avatar-studio/",
        title: "Spark Buzz",
        description: "Branded AI avatars built to travel across social feeds.",
        kicker: "AI Avatars",
        icon: <FaUserAstronaut size={18} />,
        iconBg: "#61F2C2",
      },
    ],
  },
  sections: [],
}

const customersMenu = [
  {
    to: "/customers/corporates/",
    title: "Corporates",
    description: "Built for corporate events and internal engagements.",
  },
]

const resourcesMega = {
  featured: {
    label: "Featured",
    items: [
      {
        to: "/reports/emv-calculator/",
        title: "Event EMV Calculator",
        description:
          "Estimate the earned media value of LinkedIn posts from your event.",
        icon: <FaCalculator size={18} />,
        iconBg: "#7251F4",
      },
      {
        to: "/reports/2026-event-calendar/",
        title: "2026 Master Event Calendar",
        description: "Must-attend industry events for the year ahead.",
        icon: <FaCalendarDays size={18} />,
        iconBg: "#61F2C2",
      },
      {
        to: "/reports/attendee-generated-content-impact-report-2025/",
        title: "AGC Impact Report 2025",
        description: "How attendee-generated content drives event ROI.",
        icon: <FaChartSimple size={18} />,
        iconBg: "#FF6550",
      },
      {
        to: "/reports/event-advocacy-playbook/",
        title: "The Event Advocacy Playbook",
        description: "Turn attendees into your volunteer marketing team.",
        icon: <FaBookOpen size={18} />,
        iconBg: "#1F2937",
      },
    ],
  },
  sections: [
    {
      label: "Learn",
      items: [
        { to: blogUrl("home"), title: "Blog" },
        { to: "/case-study/", title: "Case Studies" },
        { to: "/reports/", title: "All Reports" },
        { to: "/faq", title: "FAQ" },
      ],
    },
    {
      label: "Support",
      items: [
        {
          to: "https://support.premagic.com/hc/home",
          title: "Help Center",
        },
        { to: "https://status.premagic.com/", title: "Status" },
        { to: "/integrations/", title: "Integrations" },
        { to: "/partners/", title: "Partners" },
      ],
    },
  ],
}

function MobileNav(props: { hide; isSticky }) {
  return (
    <div className={`bg-white py-5 px-5 fixed inset-0 z-40`}>
      <div className="flex flex-col mt-10 justify-items-stretch	z-20 relative h-3/4 overflow-auto pt-[81px] h-[83dvh]">
        <h3 className="text-lg text-black">Solutions</h3>
        {solutionsMega.featured.items.map((item, index) => (
          <Link key={index} className="mt-5 text-black" to={item.to}>
            {item.title}
          </Link>
        ))}
        {solutionsMega.sections
          .flatMap((section) => section.items)
          .map((item, index) => (
            <Link
              key={`addon-${index}`}
              className="mt-5 text-black"
              to={item.to}
            >
              {item.title}
            </Link>
          ))}
        <div className="mb-10" />
        {/* <Link className='mt-5 text-black mb-5' to="/gleanin-vs-premagic/">Gleanin vs Premagic</Link> */}
        <h3 className="text-lg text-black">Customers</h3>
        <Link className="text-black mt-4" to="/customers/corporates/">
          Built for Corporates
        </Link>
        {/* <Link
          className="font-semibold text-lg mt-10 text-black"
          to="/integrations/"
        >
          Integrations
        </Link> */}
        <h3 className="font-semibold text-lg mt-10 text-black">Resources</h3>
        {[
          ...resourcesMega.featured.items,
          ...resourcesMega.sections.flatMap((s) => s.items),
        ].map((item, index) =>
          item.to.startsWith("http") ? (
            <a
              key={index}
              className="mt-5 text-black"
              href={item.to}
              target="_blank"
              rel="noopener noreferrer"
            >
              {item.title}
            </a>
          ) : (
            <Link key={index} className="mt-5 text-black" to={item.to}>
              {item.title}
            </Link>
          )
        )}
        <Link
          className="font-semibold text-lg mt-10 text-black"
          to="/case-study/"
        >
          Case study
        </Link>
        {caseStudies.map((caseStudy, index) => (
          <Link key={index} className="mt-5 text-black" to={caseStudy.to}>
            {caseStudy.title}
          </Link>
        ))}
      </div>
      <div className="flex items-center justify-center pt-4">
        <Button
          to="https://app.premagic.com/"
          variant="secondary"
          className="!px-20"
        >
          Login
        </Button>
      </div>
    </div>
  )
}

function StickyHeader({
  isSticky,
  handleHamburgerClick,
  isExpanded,
  bannerOffset = 0,
  isMobileUp,
  isWhiteLogo,
}) {
  return (
    <div
      className={`${
        isSticky ? header_sticky : ""
      } fixed right-0 top-0 w-full bg-white flex items-center justify-between px-5 py-3 !z-50 -translate-y-[120px] transition-all duration-300 border border-gray-200 `}
    >
      <nav
        className={`container mx-auto lg:justify-between items-center flex w-full py-2 relative !z-40`}
      >
        <Link to="/">
          {isWhiteLogo && !isSticky && !isExpanded ? (
            <img src={PremagicWhiteLogo} width={130} alt="Premagic" />
          ) : (
            <StaticImage
              src="../images/logo/premagic-logo@2xl.svg"
              width={150}
              style={{ width: isMobileUp ? 150 : 120 }}
              alt="Premagic"
              placeholder="blurred"
            />
          )}
        </Link>

        <div className="flex justify-center gap-2">
          <div className="hidden lg:flex items-center text-sm">
            <div
              className={`inline-block hover:bg-[#e0e0e0] hover:text-black px-4 rounded-full ${
                isWhiteLogo && !isSticky ? "text-white" : "text-black"
              } py-3 flex items-center group cursor-pointer relative font-medium`}
            >
              Solutions
              <div className="inline ml-2 transition duration-300 ease-in-out group-hover:rotate-180">
                {isWhiteLogo && !isSticky ? (
                  <>
                    <span className="group-hover:hidden">
                      <ArrowWhiteDown />
                    </span>
                    <span className="hidden group-hover:inline">
                      <ArrowBlackDown />
                    </span>
                  </>
                ) : (
                  <ArrowBlackDown />
                )}
              </div>
              <MegaDropdown
                featured={solutionsMega.featured}
                sections={solutionsMega.sections}
                align="left"
              />
            </div>
          </div>
          <div className="hidden lg:flex items-center text-sm">
            <div
              className={`inline-block hover:bg-[#e0e0e0] hover:text-black px-4 rounded-full ${
                isWhiteLogo && !isSticky ? "text-white" : "text-black"
              } py-3 flex items-center group cursor-pointer relative font-medium`}
            >
              Customers
              <div className="inline ml-2 transition duration-300 ease-in-out group-hover:rotate-180">
                {isWhiteLogo && !isSticky ? (
                  <>
                    <span className="group-hover:hidden">
                      <ArrowWhiteDown />
                    </span>
                    <span className="hidden group-hover:inline">
                      <ArrowBlackDown />
                    </span>
                  </>
                ) : (
                  <ArrowBlackDown />
                )}
              </div>
              <Dropdown data={customersMenu} singleColumn />
            </div>
          </div>

          <div className="hidden lg:flex items-center text-sm">
            <div
              className={`inline-block hover:bg-[#e0e0e0] hover:text-black px-4 rounded-full ${
                isWhiteLogo && !isSticky ? "text-white" : "text-black"
              } py-3 flex items-center group cursor-pointer relative font-medium`}
            >
              Case study
              <div className="inline ml-2 transition duration-300 ease-in-out group-hover:rotate-180">
                {isWhiteLogo && !isSticky ? (
                  <>
                    <span className="group-hover:hidden">
                      <ArrowWhiteDown />
                    </span>
                    <span className="hidden group-hover:inline">
                      <ArrowBlackDown />
                    </span>
                  </>
                ) : (
                  <ArrowBlackDown />
                )}
              </div>
              <MegaDropdown
                featured={caseStudiesMega.featured}
                sections={caseStudiesMega.sections}
                viewAll={caseStudiesMega.viewAll}
              />
            </div>
          </div>
          <div className="hidden lg:flex items-center text-sm">
            <div
              className={`inline-block hover:bg-[#e0e0e0] hover:text-black px-4 rounded-full ${
                isWhiteLogo && !isSticky ? "text-white" : "text-black"
              } py-3 flex items-center group cursor-pointer relative font-medium`}
            >
              Resources
              <div className="inline ml-2 transition duration-300 ease-in-out group-hover:rotate-180">
                {isWhiteLogo && !isSticky ? (
                  <>
                    <span className="group-hover:hidden">
                      <ArrowWhiteDown />
                    </span>
                    <span className="hidden group-hover:inline">
                      <ArrowBlackDown />
                    </span>
                  </>
                ) : (
                  <ArrowBlackDown />
                )}
              </div>
              <MegaDropdown
                featured={resourcesMega.featured}
                sections={resourcesMega.sections}
              />
            </div>
          </div>
        </div>

        <div className="justify-self-end hidden lg:flex items-center text-sm">
          <Button to="https://app.premagic.com/" variant="tertiary" hideIcon>
            Login
          </Button>
          <Button to="/request-a-demo/" variant="primary">
            Book a Demo
          </Button>
        </div>
        <div className="ml-auto flex items-center lg:hidden">
          {isWhiteLogo && !isSticky ? (
            <Button
              to="/request-a-demo/"
              hideIcon={!isMobileUp}
              className="max-[560px]:!px-[16px] max-[560px]:!py-[8px] max-[560px]:!text-[12px]"
            >
              Book a Demo
            </Button>
          ) : (
            ""
          )}
          <button
            onClick={() => handleHamburgerClick()}
            className={`${hamburger} ${
              isExpanded && close_icon
            } px-3 py-2 text-white hover:text-white relative z-50`}
            aria-label="Open navigation menu"
          >
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>
    </div>
  )
}
type Props = {
  isWhiteLogo?: boolean
  isHome?: boolean
}

function Header(props: Props) {
  const { isWhiteLogo = false, isHome = false } = props
  const [isExpanded, toggleExpansion] = useState(false)
  const { width } = useWindowDimensions()
  const isMobileUp = width >= 768
  const [isSticky, setIsSticky] = useState(false)

  // Get announcement banner state - use try/catch for pages without the provider
  let bannerState = { isVisible: false, bannerHeight: 0 }
  try {
    bannerState = useAnnouncementBanner()
  } catch (e) {
    // Provider not available, use defaults
  }
  const bannerOffset = bannerState.isVisible ? bannerState.bannerHeight : 0

  const handleHamburgerClick = () => {
    toggleExpansion(!isExpanded)
    document.body.classList.toggle("overflow-y-hidden")
    document.body.classList.toggle("mobile-menu-open")
  }
  const handleScroll = () => {
    if (window.scrollY > 120) {
      setIsSticky(true)
    } else {
      setIsSticky(false)
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll)
    return () => {
      window.removeEventListener("scroll", handleScroll)
      document.body.classList.remove("overflow-y-hidden")
    }
  }, [])
  // ${!isMobileUp && isSticky || isExpanded ? stickyHeader : ""}

  return (
    <div
      className={`${
        isHome
          ? "absolute w-full border-b border-[##EBEBEB] z-50 px-4 md:px-0"
          : "relative"
      }`}
    >
      {isExpanded && (
        <MobileNav hide={() => toggleExpansion(false)} isSticky={isSticky} />
      )}
      <StickyHeader
        isExpanded={isExpanded}
        isSticky={isSticky}
        handleHamburgerClick={handleHamburgerClick}
        bannerOffset={bannerOffset}
        isMobileUp={isMobileUp}
        isWhiteLogo={isWhiteLogo}
      />
      <nav
        className={`container mx-auto lg:justify-between items-center flex w-full py-5 relative !z-40`}
      >
        <Link to="/">
          {isWhiteLogo && !isSticky && !isExpanded ? (
            <img src={PremagicWhiteLogo} width={150} alt="Premagic" />
          ) : (
            <StaticImage
              src="../images/logo/premagic-logo@2xl.svg"
              width={150}
              style={{ width: isMobileUp ? 150 : 120 }}
              alt="Premagic"
              placeholder="blurred"
            />
          )}
          {/* <StaticImage
            src="../images/logo/premagic-logo@2xl.svg"
            width={150}
            style={{ width: isMobileUp ? 150 : 120 }}
            alt="Premagic"
            placeholder="blurred"
          /> */}
        </Link>

        <div className="flex justify-center gap-2">
          <div className="hidden lg:flex items-center text-sm">
            <div
              className={`inline-block hover:bg-[#e0e0e0] hover:text-black px-4 rounded-full ${
                isWhiteLogo ? "text-white" : "text-black"
              } py-3 flex items-center group cursor-pointer relative font-medium`}
            >
              Solutions
              <div className="inline ml-2 transition duration-300 ease-in-out group-hover:rotate-180">
                {isWhiteLogo ? (
                  <>
                    <span className="group-hover:hidden">
                      <ArrowWhiteDown />
                    </span>
                    <span className="hidden group-hover:inline">
                      <ArrowBlackDown />
                    </span>
                  </>
                ) : (
                  <ArrowBlackDown />
                )}
              </div>
              <MegaDropdown
                featured={solutionsMega.featured}
                sections={solutionsMega.sections}
                align="left"
              />
            </div>
          </div>
          <div className="hidden lg:flex items-center text-sm">
            <div
              className={`inline-block hover:bg-[#e0e0e0] hover:text-black px-4 rounded-full ${
                isWhiteLogo ? "text-white" : "text-black"
              } py-3 flex items-center group cursor-pointer relative font-medium`}
            >
              Customers
              <div className="inline ml-2 transition duration-300 ease-in-out group-hover:rotate-180">
                {isWhiteLogo ? (
                  <>
                    <span className="group-hover:hidden">
                      <ArrowWhiteDown />
                    </span>
                    <span className="hidden group-hover:inline">
                      <ArrowBlackDown />
                    </span>
                  </>
                ) : (
                  <ArrowBlackDown />
                )}
              </div>
              <Dropdown data={customersMenu} singleColumn />
            </div>
          </div>

          <div className="hidden lg:flex items-center text-sm">
            <div
              className={`inline-block hover:bg-[#e0e0e0] hover:text-black px-4 rounded-full ${
                isWhiteLogo ? "text-white" : "text-black"
              } py-3 flex items-center group cursor-pointer relative font-medium`}
            >
              Case study
              <div className="inline ml-2 transition duration-300 ease-in-out group-hover:rotate-180">
                {isWhiteLogo ? (
                  <>
                    <span className="group-hover:hidden">
                      <ArrowWhiteDown />
                    </span>
                    <span className="hidden group-hover:inline">
                      <ArrowBlackDown />
                    </span>
                  </>
                ) : (
                  <ArrowBlackDown />
                )}
              </div>
              <MegaDropdown
                featured={caseStudiesMega.featured}
                sections={caseStudiesMega.sections}
                viewAll={caseStudiesMega.viewAll}
              />
            </div>
          </div>
          <div className="hidden lg:flex items-center text-sm">
            <div
              className={`inline-block hover:bg-[#e0e0e0] hover:text-black px-4 rounded-full ${
                isWhiteLogo ? "text-white" : "text-black"
              } py-3 flex items-center group cursor-pointer relative font-medium`}
            >
              Resources
              <div className="inline ml-2 transition duration-300 ease-in-out group-hover:rotate-180">
                {isWhiteLogo ? (
                  <>
                    <span className="group-hover:hidden">
                      <ArrowWhiteDown />
                    </span>
                    <span className="hidden group-hover:inline">
                      <ArrowBlackDown />
                    </span>
                  </>
                ) : (
                  <ArrowBlackDown />
                )}
              </div>
              <MegaDropdown
                featured={resourcesMega.featured}
                sections={resourcesMega.sections}
              />
            </div>
          </div>
        </div>

        <div className="justify-self-end hidden lg:flex items-center text-sm">
          <Button to="https://app.premagic.com/" variant="tertiary" hideIcon>
            Login
          </Button>
          <Button to="/request-a-demo/" variant="primary">
            Book a Demo
          </Button>
        </div>
        <div className="ml-auto flex items-center lg:hidden">
          {isSticky ? (
            <Button to="/request-a-demo/" variant="primary">
              Book a Demo
            </Button>
          ) : (
            ""
          )}
          <button
            onClick={() => handleHamburgerClick()}
            className={`${hamburger} ${
              isExpanded && close_icon
            } px-3 py-2 text-white hover:text-white relative z-50`}
            aria-label="Open navigation menu"
          >
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>
    </div>
  )
}

export default Header
